import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitGetTestsScoreData = {
  user: string;
  id: string;
};

export type ResponseGetTestScoreData = {
  scoreList: number[];
  score: number;
};

export const getTestsScore = async (data: SubmitGetTestsScoreData) => {
  const response = await axios.get(`${rootUrl}/psychologist/tests/score`, {
    params: {
      user: data.user,
      token: getCookies('auth'),
      id: data.id,
    },
    headers: {
      'Cache-Control': 'no-store',
    },
  });

  return response.data;
};
